export default "__VITE_ASSET__D__fE98x__"